// extracted by mini-css-extract-plugin
module.exports = {"cardsWrapper":"OurValueSection_cardsWrapper__NxBi9","cardContainer":"OurValueSection_cardContainer__z_nSg"};